import { Link, Typography } from "@mui/material";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { useLinks } from "hooks/useLinks";

export const Legalese = () => {
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const links = useLinks();

	return (
		<Typography
			variant="caption"
			textAlign="center"
			sx={{ padding: "0 0 1.4rem", fontSize: { xs: "11px", sm: "14px" } }}
		>
			By confirming your purchase, you agree to the{" "}
			<Link
				href={links.tos.path}
				target="_blank"
				rel="noreferrer"
				onClick={() => {
					reportEvent("terms_of_service_click", {
						source: "loyalty_purchase_confirm_dialog"
					});
					reportPlaygamiEvent("tp.web_frontend", {
						event_name: "terms_of_service_click",
						event_type: "loyalty_purchase_confirm_dialog",
						action: "terms_of_service_click",
						source: "loyalty_purchase_confirm_dialog"
					});
				}}
			>
				Terms of Sale
			</Link>
			,<br /> You’ll be charged immediately.
		</Typography>
	);
};
